import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import useVirtualViewport from "../../../../hooks/useVirtualViewport";
import { Box, Typography, useTheme } from "@mui/material";
import { useAppSelector } from "../../../../hooks/useRedux";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left.svg";
import CustomSelectOption from "../../../components/CustomSelectOption";
import CustomInput from "../../../components/CustomInput";
import FolderOpenIcon from "../../../../media/images/icons/folder-open";
import FolderAddIcon from "../../../../media/images/icons/folder-add";
import CameraFillIcon from "../../../../media/images/icons/camera-fill";
import CustomButton from "../../../components/CustomButton";
import SmsTrackingIcon from "../../../../media/images/icons/sms-tracking";

export default function SendTicketPage() {
  const divRef = useRef<HTMLDivElement>(null);

  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  const [stepIndex, setStepIndex] = useState(4);

  const theme = useTheme();

  const viewport = useVirtualViewport();
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <>
      <MobileHeader title={HeadTitle()} hasScroll={hasScroll} />
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "16px",
        }}
      >
        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "background.default",
            padding: "16px",
            borderRadius: "16px",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "600",
              color: "primary.main",
              fontSize: "16px",
            }}
          >
            ارسال تیکت پشتیبانی جدید{" "}
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "16px",
            }}
          >
            <Typography>درخواست کننده:</Typography>
            <Typography>رضا یعقوبی‌فریان پور</Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              marginTop: "8px",
            }}
          >
            <CustomSelectOption
              selectFor={"year"}
              handleChange={() => console.log("sdsd")}
              options={[
                {
                  label: "بخش مربوطه را انتخاب کنید",
                  value: 1,
                  disabled: true,
                },
                {
                  label: "بزرگ مقیاس",
                  value: 2,
                  disabled: false,
                },
                {
                  label: "کوچک مقیاس",
                  value: 3,
                  disabled: false,
                },
              ]}
              value={1}
            />
            <CustomInput placHolder="عنوان درخواست را وارد کنید" />
            <CustomInput textArea placHolder="متن درخواست را وارد کنید..." />

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid gray",
                padding: "8px",
                backgroundColor: "info.light",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FolderOpenIcon color={theme.palette.primary.main} />
                <Typography sx={{ color: "primary.main", fontWeight: "600" }}>
                  اسم فایل پیوست شده
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  alignItems: "center",
                  borderWidth: "1px",
                  borderColor: theme.palette.primary.main,
                  borderStyle: "solid",
                  padding: "8px 4px",
                  borderRadius: "8px",
                  backgroundColor: "info.light",
                }}
              >
                <FolderAddIcon color={theme.palette.primary.main} />
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                  color="primary.main"
                >
                  پیوست فایل به تیکت
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  alignItems: "center",
                  borderWidth: "1px",
                  borderColor: theme.palette.primary.main,
                  borderStyle: "solid",
                  padding: "8px 4px",
                  borderRadius: "8px",
                  backgroundColor: "info.light",
                }}
              >
                <CameraFillIcon color={theme.palette.primary.main} />
                <Typography
                  sx={{
                    fontWeight: "600",
                  }}
                  color="primary.main"
                >
                  پیوست عکس از طریق دوربین موبایل
                </Typography>
              </Box>
            </Box>

            <CustomButton
              // loading={loading}
              // onClick={formik.handleSubmit}
              flexDirection="row"
              title="ارسال درخواست به ایستگاه"
              justifyContent="center"
              bgColor="secondary.main"
              width="100%"
              fSize="16px"
              fontWeight={600}
              px="10px"
              py="10px"
              borderRadius="10px"
              icon1={<SmsTrackingIcon color="#ffffff" size={32} />}
              mt="16px"
            />
          </Box>
        </Box>
      </Box>
      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}

function HeadTitle() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: "secondary.main",
          fontWeight: 600,
        }}
      >
        پشتیبانی{" "}
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        ایجاد درخواست جدید
      </Typography>
    </Box>
  );
}
